import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { buildSelectOptionTypes } from './build-select-option-types.js'

export function genTypesContent(ctx: EntityCtx): string {
  const idPlaceholder = '$' + '{id}'
  const tagEntries = [
    `  all: '${ctx.cacheTag}'`,
    `  byId: (id: string) => \`${ctx.plural}:id:${idPlaceholder}\``
  ]
  if (ctx.hasSlug) {
    tagEntries.push(`  bySlug: (slug: string) => \`${ctx.plural}:slug:\${slug}\``)
  }

  const parts = [
    ctx.dataInterface,
    ctx.responseInterface,
    ctx.filtersInterface,
    ctx.hasCreatableSelectFields ? buildSelectOptionTypes(ctx) : null,
    ctx.createInterface,
    `export interface ${ctx.Singular}CreateResult {\n  success: boolean\n  error?: string\n  ${ctx.camelSingular}?: ${ctx.Singular}\n}`,
    ctx.updateInterface,
    `export interface ${ctx.Singular}UpdateResult {\n  success: boolean\n  error?: string\n  ${ctx.camelSingular}?: ${ctx.Singular}\n}`,
    `export interface ${ctx.Singular}DeleteResult {\n  success: boolean\n  error?: string\n}`,
    `export const ${ctx.camelPlural}CacheTags = {\n${tagEntries.join(',\n')}\n} as const`
  ]
  return `${parts.filter(Boolean).join('\n\n')}\n`
}
